function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M20.8504 0.00305269C9.53052 -0.190344 0.196451 8.82966 0.00305471 20.1495C-0.106794 26.568 2.75392 32.3366 7.30879 36.1728C7.60662 35.9129 7.92611 35.6746 8.28119 35.4812L14.3979 32.1447C15.2001 31.7069 15.6999 30.866 15.6999 29.9516V27.4452C15.6999 27.4452 13.9044 25.2977 13.2198 22.314C12.6519 21.9466 12.2713 21.3114 12.2713 20.5881V17.845C12.2713 17.2416 12.5398 16.7024 12.9567 16.3249V12.3595C12.9567 12.3595 12.1421 6.18864 20.4992 6.18864C28.8562 6.18864 28.0416 12.3595 28.0416 12.3595V16.3249C28.4594 16.7024 28.727 17.2416 28.727 17.845V20.5881C28.727 21.5103 28.1082 22.2862 27.2681 22.5453C26.8 24.0004 26.1247 25.3875 25.232 26.6484C25.0069 26.9664 24.7964 27.2356 24.6123 27.4452V30.0151C24.6123 30.9611 25.1469 31.8268 25.9932 32.2492L32.5431 35.5238C32.9361 35.7202 33.2912 35.9686 33.6184 36.2447C38.0356 32.5609 40.8893 27.053 40.9953 20.8504C41.1903 9.53052 32.171 0.196449 20.8504 0.00305269Z",
  fill: "#F17D32"
});

var SvgUserLogo = function SvgUserLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 37,
    viewBox: "0 0 41 37",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user-logo.fc2133f5.svg";
export { ForwardRef as ReactComponent };